import { Button, makeStyles } from "@material-ui/core";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import clsx from "clsx";
import React from "react";
import { IMAGE_FILE, VIDEO_FILE } from "../../../constants/formInputTypes";
import Text from "../Text";


const useStyles = makeStyles((theme) => ({
    root: {
        // display: "flex",
        width: "100%",
        alignItems: "center",
        padding: theme.spacing(2, 0, 2, 0),
    },
    input: {
        display: "none",
    },
    label: {
    },
    inputLabel: {
        padding: theme.spacing(2.5),
        marginLeft: 'auto',
        boxSizing: 'border-box',
        width: "100%",
        minHeight: 150,
        // borderStyle: 'dashed',
        // borderWidth: 2,
        // borderColor: theme.palette.ascents.base,
        background: `${theme.palette.ascents.baseDark} !important`,
        overflow: 'hidden',
        zIndex: 0,
        border: "none",
        "&:after": {
            content: "''",
            position: "absolute",
            top: '0',
            left: '0',
            right: '0',
            bottom: '0',
            borderStyle: 'dashed',
            borderWidth: 2,
            borderColor: theme.palette.ascents.base,
            zIndex: -1,
        },
        "&:before": {
            content: "''",
            position: "absolute",
            top: '2px',
            left: '2px',
            right: '2px',
            bottom: '2px',
            backgroundColor: theme.palette.ascents.base,
            zIndex: -1,
        }
    },
    previewImg: {
        width: "100%",
        height: "100%",
        objectFit: "contain",
        maxHeight: "150px",
    },
    previewImgParent: {
        width: ({ width }) => width,
        height: ({ height }) => height,
        maxWidth: "100%",
    },
    previewVideoParent: {
        width: ({ width }) => width,
        height: ({ height }) => height,
        maxWidth: "100%",
    },
    imageName: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
}));

const FileInput = ({
    accept,
    fileType,
    width = "auto",
    height = "auto",
    onChange,
    ascent,
    buttonLabel = "Choose File",
    id,
    label = "",
    className,
    children,
    previewUrl,
    imageName,
    readOnly = false,
    ...props
}) => {
    const classes = useStyles({ ascent, width, height });

    const RenderPreview = () => {
        switch (fileType) {
            case IMAGE_FILE:
                return (
                    <div className={classes.previewImgParent}>
                        <img
                            src={previewUrl}
                            alt={imageName}
                            className={classes.previewImg}
                        />
                    </div>
                )
            case VIDEO_FILE:
                return (
                    <video controls className={classes.previewVideoParent}>
                        <source src={previewUrl} type="video/mp4" />
                        <source src={previewUrl} type="video/webm" />
                        <small>Your browser does not support the video tag.</small>
                    </video>
                )

            default:
                break;
        }
    }

    return (
        <div className={clsx(classes.root)}>
            <Button
                component="label"
                htmlFor={id}
                className={classes.inputLabel}
                variant="outlined"
                ascent={"systemMetalLight"}
                disabled={readOnly}
            >
                {previewUrl ? (
                    <div>
                        <RenderPreview />
                        {
                            !readOnly && <Text variant='p' color='primary'>
                                <Text variant="body2" className={classes.imageName}>
                                    {imageName || ''}
                                </Text>
                                Change File
                            </Text>
                        }
                    </div>
                ) : (
                    <>
                        <AttachFileIcon fontSize="small" />
                        <Text variant="body2">{imageName || buttonLabel}</Text>

                    </>
                )}

                <input
                    accept={accept}
                    type="file"
                    onChange={onChange}
                    className={classes.input}
                    readOnly={readOnly}
                    {...props}
                />
            </Button>

        </div>
    );
};

FileInput.propTypes = {};

export default FileInput;
